export const formatWalletId = (walletId: string | undefined, toUpper = true): string => {
  if (typeof walletId !== 'string') return '';
  if (walletId.length < 12) return walletId;
  const res = `${walletId.substring(5, 0)}...${walletId.substring(walletId.length - 5, walletId.length)}`;
  return toUpper ? res.toUpperCase() : res;
};
